export default __webpack_public_path__ + "static/media/icon-chest.9d19c56a.webp";